import { TipsVariantEnum } from '~/component/tips/enum/variant.enum';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';

export class UserError extends Error {
  public description: string;
  public header: string;
  public iconName: VtmnPlayIconTypeEnum;
  public variant: TipsVariantEnum;

  constructor(
    description: string,
    header: string,
    iconName: VtmnPlayIconTypeEnum = VtmnPlayIconTypeEnum.WarningError,
    variant: TipsVariantEnum = TipsVariantEnum.DANGER
  ) {
    super(description);

    this.description = description;
    this.header = header;
    this.iconName = iconName;
    this.variant = variant;
  }
}
